import type { FC } from 'react';
import type { EvalResolutionCheck } from '@queries/evalRuns';

interface ResolutionCheckProps {
  /** Latest check for this run (the detail response sorts newest first). */
  latestCheck?: EvalResolutionCheck;
}

/**
 * The AI re-check's status, as a caption line in the results footer — only
 * when the last one failed. A running check takes over the drawer body
 * (`RecheckProgress`); a completed one needs no line of its own, as the
 * findings it closed now read as resolved.
 */
export const ResolutionCheck: FC<ResolutionCheckProps> = ({ latestCheck }) => {
  if (latestCheck?.status !== 'FAILED') return null;

  return (
    <p className="text-gray-500" data-testid="pbqa-resolution-check-error" role="alert">
      The last re-check failed{latestCheck.error_message ? ` — ${latestCheck.error_message}` : ''}.
    </p>
  );
};
